import React from 'react';

const SvgShare = (props) => (
  <svg width={15} height={17} {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.803.783a2.354 2.354 0 0 0-2.36 2.347c0 .148.015.295.043.44l-5.6 3.247a2.368 2.368 0 0 0-1.525-.556A2.354 2.354 0 0 0 0 8.609a2.354 2.354 0 0 0 2.36 2.348 2.368 2.368 0 0 0 1.524-.558l5.602 3.25a2.335 2.335 0 0 0-.043.438 2.354 2.354 0 0 0 2.36 2.348 2.354 2.354 0 0 0 2.36-2.348 2.354 2.354 0 0 0-2.36-2.348c-.558 0-1.098.199-1.524.558l-5.6-3.25a2.335 2.335 0 0 0 0-.877l5.598-3.248c.427.36.967.556 1.526.556a2.354 2.354 0 0 0 2.36-2.348 2.354 2.354 0 0 0-2.36-2.347z"
    />
  </svg>
);

export default SvgShare;
